module.exports = __webpack_public_path__ + "img/wexin_code.79b73378.jpg";